module.exports = __webpack_public_path__ + "static/img/200212.f3e87abd.png";